import { NgModule } from "@angular/core";
import { PojedinacnaEvidencijaPdvTabsComponent } from "./pojedinacna-evidencija-pdv/pojedinacna-evidencija-pdv-tabs.component";
import { EpdvComponent } from './epdv.component';
import { EpdvRoutingModule } from "./epdv-routing.module";
import { LookupsModule } from "../lookups/lookups.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { PojedinacnaEvidencijaPdvUpdateComponent } from './pojedinacna-evidencija-pdv/pojedinacna-evidencija-pdv-update.component';
import { FakModule } from "../fak/fak.module";
import { PojedinacnaEvidencijaPdvTabUpdateComponent } from './pojedinacna-evidencija-pdv/pojedinacna-evidencija-pdv-tab-update.component';
import { AppComponent } from "../app.component";
import { AppModule } from "../app.module";
import { FilterWithKomitentComponent } from "./_filters/epdv-filter-with-komitent.component";




@NgModule({
    imports:[
        EpdvRoutingModule,
        LookupsModule,
        NgbModule,
        TranslateModule,
        FakModule
    ],
    declarations: [PojedinacnaEvidencijaPdvTabsComponent, 
                    EpdvComponent, 
                    PojedinacnaEvidencijaPdvUpdateComponent,
                    PojedinacnaEvidencijaPdvTabUpdateComponent,
                    FilterWithKomitentComponent],

    // entryComponents: [
    //     FilterWithKomitentComponent
    // ],

})
export class EPdvModule{}